<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs6>
          <v-btn flat to="/commercial" exact class="ma-0">  
            <v-icon color="grey lighten-1" class="mr-3">fas fa-angle-left</v-icon>
            <div class="headline">Location</div>
          </v-btn>
        </v-flex>
        <v-flex xs6 class="test-xs-right">
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-md>
              <v-layout row wrap align-center>
                <v-flex xs8>
                  <div class="headline">{{ indicateurLoc('misesEnLoc', month) }} Mises en loc ({{ $moment(month+1, 'MM').format('MMMM') }})</div>
                  <div>Objectif {{ $moment(month+1, 'MM').format('MMMM') }} : {{ indicateurLoc('objectifs', month) }}</div>
                  <div>Objectif annuel : {{ indicateurLoc('objectifs', 12) }}</div>
                </v-flex>
                <v-flex xs4 class="text-xs-center">
                  <progress-chart :data="indicateurLoc('misesEnLoc', month)/indicateurLoc('objectifs', month)" :width="74" :height="74"></progress-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
        <v-flex xs12 lg6>
          <v-card>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12>
                  <line-chart :data="chartData"></line-chart>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LineChart from '@/components/charts/LineChart.js'
import ProgressChart from '@/components/charts/ProgressChart'
import { mapGetters } from 'vuex'

export default {
  name: 'Gestion',
  components: {
    LineChart, ProgressChart
  },
  data() {
    return {
      agence : 'Toutes',
    }
  },
  computed: {
    ...mapGetters(['indicateurLoc', 'serieLoc']),
    month() {
      return this.serieLoc('misesEnLoc').length - 1
    },
    chartData() {
      return {
        labels: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        datasets: [
          {
            label: 'Mises en loc',
            backgroundColor: '#E53935',
            data: this.serieLoc('misesEnLoc')
          },
          {
            label: 'Objectifs',
            backgroundColor: '#FFCC80',
            data: this.serieLoc('objectifs')
          },
        ]
      }
    },
  }
}
</script>

<style scoped>

</style>
